// extracted by mini-css-extract-plugin
export default {"fakeContent":"StoryLoader_fakeContent__NUU+V"};